import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from './views/iori/layout/Layout'

import ioriRouter from "./routers/iori";
import businessRouter from './routers/business'
import defaultRouter from './routers/default'
import ZiGuiRouter from './routers/zigui'
import BeiJingRouter from './routers/beijing-router'
import BJSinglePage from './routers/BJ-single-page'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    permissions: []              允许访问的权限列表(appName$Service$resourceCode$operationCode)
  }
 * 不需要动态判断权限的路由，如登录页、404、等通用页面
 **/
export const constantRouterMap = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path*',
                component: () => import('@/views/iori/redirect/index')
            }
        ]
    },
    {path: '/login', component: () => import('@/views/iori/login/index'), hidden: true},
    {path: '/forget', component: () => import('@/views/iori/forget/index'), hidden: true},
    {path: '/404', component: () => import('@/views/iori/errorPage/404'), hidden: true},
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        name: 'Home',
        hidden: true,
        children: [{
            path: 'personalCenter',
            component: () => import('@/views/iori/personalCenter/index')
        }]
    },
    {
        path: '/tested',
        component: Layout,
        redirect: 'iot/alarm/realAlarm',
        hidden: true,
        children: [{
            path: 'index',
            component: () => import('@/views/iori/personalCenter/index')
        }]
    },
]

/**
 * 需要动态判断权限并通过 addRouters 动态添加的页面
 */
export const asyncRouterMap = [
    ...ioriRouter,
    ...businessRouter,
    ...defaultRouter,
    ...ZiGuiRouter,
    ...BeiJingRouter,
    ...BJSinglePage
]

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
})
